import $ from "zepto";
import ConfirmPop from "confirmPop";
import evt from "event";
import "../ui/imgVerifyCode.less";

class ImgVerifyCode {
  constructor(hasMask = false) {
    this.confirmPop = new ConfirmPop("", {
      needNewOverlay: true,
      hasMask: hasMask,
    });

    // 为了使得验证码图片可以盖到lightLogin上
    this.confirmPop.$pop.$overlay.css("zIndex", "51");

    // 如果同一个页面不但使用了imgVerifyCode模块还要使用confirmPop模块
    // imgVerifyCode模块对confirmPop的样式进行了重写
    // 为了不让imgVerifyCode模块的confirm-pop样式影响同一页面需要使用confirmPop的样式
    // 所以为imgVerifyCode模块重新添加一个样式名

    this.confirmPop.$elem.addClass("img-verify-code");

    this.confirmPop.on("confirm", () => {
      // this.confirmPop.hide()
      this.emit("confirm", this.$input.val());
    });

    this.render();
  }
  render() {
    var $elem = $(`
      <div class='text'>请输入图形码</div>
      <div class='bottom'>
        <input type='tel' maxlength='4' class='input img-verify-code-input' placeholder='请输入'>
				<img id='clear-num-code' width='16px' height='16px' src="https://img.piaoniu.com/img/icon_close.png" />
        <img class='verify-img' />
      </div>
    `);
    this.$img = $elem.find(".verify-img");
    this.$img.click(() => {
      this.freshImg();
    });
    this.$input = $elem.find(".input");
    this.clearNumCode = $elem.find("#clear-num-code");
    this.clearNumCode.click(() => {
      this.$input.val("");
    });
    this.confirmPop.$elem
      .find(".head")
      .empty()
      .append($elem);
  }
  freshImg() {
    var timestamp = new Date().getTime();
    this.$img.attr("src", "");
    setTimeout(() => {
      this.$img.attr("src", `/api/v1/user/captcha?${timestamp}`);
    }, 50);
  }
  show() {
    this.freshImg();
    this.$input.val("");
    this.confirmPop.show();
    // 检测 iOS
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    if (isIOS) {
      // iOS 需要用户交互才能聚焦，可以模拟点击
      this.$input.trigger("click");
      setTimeout(() => {
        this.$input.focus();
      }, 200);
    } else {
      // 非 iOS 直接聚焦
      this.$input.focus();
    }
  }
  hide() {
    this.confirmPop.hide();
    this.confirmPop.removeMask();
  }
}

evt.mixin(ImgVerifyCode);

export default ImgVerifyCode;



// WEBPACK FOOTER //
// ./src/mods/imgVerifyCode.js